import { useAssignProductToUserMutation, useGetMyOrderListQuery } from "../../order/productsApi";
import { createClickableLink } from "../../../components/common/datatable/DataTableUtils";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { useState } from "react";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { useFindUserSettingsByGroupNameQuery } from "../../../components/common/userSetting/userSettingsApi";
import IconButton from "../../../components/common/form/IconButton";
import { formatValueAsDate, formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import { handleRTKQuery } from "../../../helpers/utils/RtkQueryUtils";
import { toast } from "react-toastify";
import success = toast.success;
import { getProductStatusDotInfo, getShortProductName, showToast } from "../../../helpers/utils/Utils";
import AddFollowUpForProduct from "../../order/modal/AddFollowUpForProduct";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";


const MyWorkTab = () => {


    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("My Work");
    const [assignNextProductApi, assignNextProductApiResponse] = useAssignProductToUserMutation();
    const [curProduct, setCurProduct] = useState({});
    const [orderId, setOrderId] = useState<any>();
    const [showFollowUpModal, setShowFollowUpModal] = useState(false);


    const handleNextTask = async () => {
        await handleRTKQuery(
            async () => {
                return await assignNextProductApi("").unwrap();
            },
            (response: any) => {
                if (response != null)
                    if(response.message === "No product found to assign")
                    showToast(response.message ,"info")
                else{
                    showToast(response.message ,"success")
                }
            }
        );
    }

    const columns: DataTableColumn[] = [
        {
            label: "Order No.",
            accessor: "customerOrderNumber",
            cell: (props: any) => {
                let path = `/orders/${props.row.original.orderId}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["ORDR-R", "ORDR-V"]);
            },
            canSort: false,
        },
        {
            label: "Customer",
            accessor: "customerId",
            canSort: false,
        },

        {
            label: "County",
            accessor: "county",
            canSort: false,
        },
        {
            label: "Address",
            accessor: "addressLine1",
            canSort: false,
        },
        {
            label: "Legal",
            accessor: "legalDescription",
            canSort: false,
        },

        {
            label: "Product", accessor: "type", canSort: false, cell: (props: any) => {
                return (<>
                    <div className={props.row.original.followUpTypeDTO == null ? "product-div" : undefined}>

                        {hasPermission(["PROFOLLUP-V"]) && props.row.original.followUp != null &&
                            <i className={hasPermission(["PROFOLLUP-R"]) ? "fa fa-solid fa-tag mr-1 cursor-pointer" : "fa fa-solid fa-tag mr-1"}
                                onClick={(e) => {
                                    if (hasPermission(["PROFOLLUP-R"])) {
                                        e.preventDefault();
                                        setCurProduct(
                                            {
                                                id: props.row.original.productId,
                                                followUp: props.row.original.followUp,
                                                followUpTypeDTO: props.row.original.followUpTypeDTO,
                                            }
                                        );
                                        setOrderId(props.row.original.orderId);
                                        setShowFollowUpModal(true);
                                    }
                                }}
                                title={props.row.original.followUpTypeDTO != null
                                    ? props.row.original.followUpTypeDTO.name + ' : ' + formatValueAsDate(props.row.original.followUp.followUpAdded, "MM/DD/YY") + " " + props.row.original.followUp.followUpMessage
                                    : undefined}

                                style={{ color: props.row.original.followUpTypeDTO != null ? props.row.original.followUpTypeDTO.hexColor : '' }} />
                        }

                        {props.row.original.assignedTo !== null ?

                            <i title={props.row.original.assignedTo + " (" + getProductStatusDotInfo(props.row.original.productStatus).title + ")"}
                                className="fa fa-user mr-1 default-cursor"
                                style={{ color: getProductStatusDotInfo(props.row.original.productStatus).color }} /> :
                            <i className="product_status_circle fa fa-solid fa-circle mr-1 default-cursor"
                                style={{ color: getProductStatusDotInfo(props.row.original.productStatus).color }}
                                title={getProductStatusDotInfo(props.row.original.productStatus).title}
                            />

                        }
                        <span>{getShortProductName(props.row.original.type)}</span>
                    </div>
                </>)
            }
        },

        {
            label: "Status", accessor: "productStatus",
        },
        {
            label: <i title="Rush" className="fa fa-clock fa-sm " />, accessor: "rushDate",
            visibility: { hasShowSetting: false },
            canSort: false,
            cell: (props: any) => <>
                {props.value ? <i title="Rush" className="fa fa-clock fa-sm default-cursor" /> : ''}

            </>

        },
        {
            label: "Assigned Date", accessor: "assignedDate", canSort: false, cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.assignedDate);
            }
        }
    ]


    return (
        <>

            <div className="gap-1 text-text-0 flex justify-end absolute right-[17px] top-4">
                <IconButton icon={""}
                    label={"Get Next Task"}
                    title={"Get the next task based on the rules defined by the teams you are in"}
                    onClick={handleNextTask}
                    isLoading={assignNextProductApiResponse.isLoading}
                    className={'px-3.5 py-1 rounded-xl text-base\n'}
                />
            </div>


            <div className='shadow-[0px_0px_5px_rgba(0,0,0,0.2)] pb-5 rounded'>
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useGetMyOrderListQuery
                    }}
                    defaultFilter={{
                        pageNumber: 0,
                        pageSize: 15,
                    }}
                    userSettingGroup='My Work'
                    defaultSortOptions={{
                        accessor: 'assignedDate',
                        direction: 'desc'
                    }}
                    appendFilterToUrl={false}
                />
            </div>

            {showFollowUpModal && <AddFollowUpForProduct show={showFollowUpModal}
                setShow={setShowFollowUpModal}
                isHoa={false}
                btnName={"Update"}
                currentProduct={curProduct}
                orderId={orderId}
            />}
        </>
    )
}
export default MyWorkTab;